import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function TrendingUp($$anchor, $$props) {
	const iconNode = [
		["path", { "d": "M16 7h6v6" }],
		["path", { "d": "m22 7-8.5 8.5-5-5L2 17" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiVHJlbmRpbmdVcC5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgaW1wb3J0IEljb24gZnJvbSAnLi9JY29uLnN2ZWx0ZSc7XG4gIGNvbnN0IGljb25Ob2RlOiBbc3RyaW5nLCBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+XVtdID0gW1tcInBhdGhcIiwgeyBcImRcIjogXCJNMTYgN2g2djZcIiB9XSwgW1wicGF0aFwiLCB7IFwiZFwiOiBcIm0yMiA3LTguNSA4LjUtNS01TDIgMTdcIiB9XV07XG4gIGxldCByZXN0ID0gJHByb3BzKCk7XG48L3NjcmlwdD5cbjxJY29uIHtpY29uTm9kZX0gey4uLnJlc3R9IC8+XG4iXSwibWFwcGluZ3MiOiI7O09BQ1MsSUFBSSxNQUFNLGVBQWU7O3NEQURsQyxDQUFDO09BRU8sUUFBNEM7R0FBSyxNQUFNLElBQUksR0FBRyxFQUFFLFdBQVc7R0FBTSxNQUFNLElBQUksR0FBRyxFQUFFLHdCQUF3Qjs7O0tBQzFILElBQUk7Ozs7Ozs7O1FBRVcsSUFBSTs7QUFEMUIsQ0FBQyJ9